import React from 'react';
import './ServicePage.css';

const Kasko = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>🛡️ Kasko Sigortası</h1>
          <p>Araçlarınız için kapsamlı kasko sigortası</p>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <h2>Kasko Sigortası Nedir?</h2>
            <p>
              Kasko sigortası, aracınızın çarpma, çalınma, yangın, doğal afetler 
              gibi risklere karşı korunmasını sağlayan gönüllü bir sigorta türüdür. 
              Trafik sigortasından farklı olarak, aracınızın kendisini korur.
            </p>
          </section>

          <section className="service-section">
            <h2>Kapsamı</h2>
            <ul className="service-list">
              <li>Çarpma ve çarpışma hasarları</li>
              <li>Hırsızlık ve gasp</li>
              <li>Yangın ve patlama</li>
              <li>Doğal afetler (sel, deprem, fırtına)</li>
              <li>Cam kırılması</li>
              <li>Çizik ve vandalizm</li>
            </ul>
          </section>

          <section className="service-section">
            <h2>Avantajları</h2>
            <ul className="service-list">
              <li>Aracınızın değerini korur</li>
              <li>Beklenmedik masraflardan korur</li>
              <li>Hızlı hasar tespit ve ödeme</li>
              <li>Esnek paket seçenekleri</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Kasko;

